import { LanguageName } from '../../enums/language-name.enum';
import { LanguageCode } from '../../enums/language-service.enum';

export class GoogleLanguageDictionary {

  public language = [
    { code: LanguageCode.af, name: LanguageName.af },
    { code: LanguageCode.sq, name: LanguageName.sq },
    { code: LanguageCode.ar, name: LanguageName.ar },
    { code: LanguageCode.hy, name: LanguageName.hy },
    { code: LanguageCode.az, name: LanguageName.az },
    { code: LanguageCode.be, name: LanguageName.be },
    { code: LanguageCode.bn, name: LanguageName.bn },
    { code: LanguageCode.bs, name: LanguageName.bs },
    { code: LanguageCode.bg, name: LanguageName.bg },
    { code: LanguageCode.my, name: LanguageName.my },
    { code: LanguageCode.ca, name: LanguageName.ca },
    { code: LanguageCode.zh, name: LanguageName.zh },
    { code: LanguageCode.zh_CN, name: LanguageName.zh_CN },
    { code: LanguageCode.zh_HK, name: LanguageName.zh_HK },
    { code: LanguageCode.zh_TW, name: LanguageName.zh_TW },
    { code: LanguageCode.hr, name: LanguageName.hr },
    { code: LanguageCode.cs, name: LanguageName.cs },
    { code: LanguageCode.da, name: LanguageName.da },
    { code: LanguageCode.nl, name: LanguageName.nl },
    { code: LanguageCode.eu, name: LanguageName.eu },
    { code: LanguageCode.en, name: LanguageName.en },
    { code: LanguageCode.en_AU, name: LanguageName.en_AU },
    { code: LanguageCode.en_GB, name: LanguageName.en_GB },
    { code: LanguageCode.et, name: LanguageName.et },
    { code: LanguageCode.fa, name: LanguageName.fa },
    { code: LanguageCode.fi, name: LanguageName.fi },
    { code: LanguageCode.fil, name: LanguageName.fil },
    { code: LanguageCode.fr, name: LanguageName.fr },
    { code: LanguageCode.fr_CA, name: LanguageName.fr_CA },
    { code: LanguageCode.gl, name: LanguageName.gl },
    { code: LanguageCode.ka, name: LanguageName.ka },
    { code: LanguageCode.de, name: LanguageName.de },
    { code: LanguageCode.el, name: LanguageName.el },
    { code: LanguageCode.gu, name: LanguageName.gu },
    { code: LanguageCode.iw, name: LanguageName.iw },
    { code: LanguageCode.hi, name: LanguageName.hi },
    { code: LanguageCode.hu, name: LanguageName.hu },
    { code: LanguageCode.is, name: LanguageName.is },
    { code: LanguageCode.id, name: LanguageName.id },
    { code: LanguageCode.it, name: LanguageName.it },
    { code: LanguageCode.ja, name: LanguageName.ja },
    { code: LanguageCode.kn, name: LanguageName.kn },
    { code: LanguageCode.kk, name: LanguageName.kk },
    { code: LanguageCode.km, name: LanguageName.km },
    { code: LanguageCode.ko, name: LanguageName.ko },
    { code: LanguageCode.ky, name: LanguageName.ky },
    { code: LanguageCode.lo, name: LanguageName.lo },
    { code: LanguageCode.lv, name: LanguageName.lv },
    { code: LanguageCode.lt, name: LanguageName.lt },
    { code: LanguageCode.mk, name: LanguageName.mk },
    { code: LanguageCode.ms, name: LanguageName.ms },
    { code: LanguageCode.ml, name: LanguageName.ml },
    { code: LanguageCode.mr, name: LanguageName.mr },
    { code: LanguageCode.mn, name: LanguageName.mn },
    { code: LanguageCode.my, name: LanguageName.my },
    { code: LanguageCode.ne, name: LanguageName.ne },
    { code: LanguageCode.no, name: LanguageName.no },
    { code: LanguageCode.pl, name: LanguageName.pl },
    { code: LanguageCode.pt, name: LanguageName.pt },
    { code: LanguageCode.pt_BR, name: LanguageName.pt_BR },
    { code: LanguageCode.pt_PT, name: LanguageName.pt_PT },
    { code: LanguageCode.pa, name: LanguageName.pa },
    { code: LanguageCode.ro, name: LanguageName.ro },
    { code: LanguageCode.ru, name: LanguageName.ru },
    { code: LanguageCode.sr, name: LanguageName.sr },
    { code: LanguageCode.siv, name: LanguageName.siv },
    { code: LanguageCode.sk, name: LanguageName.sk },
    { code: LanguageCode.sl, name: LanguageName.sl },
    { code: LanguageCode.es, name: LanguageName.es },
    { code: LanguageCode.es_419, name: LanguageName.es_419 },
    { code: LanguageCode.sw, name: LanguageName.sw },
    { code: LanguageCode.sv, name: LanguageName.sv },
    { code: LanguageCode.ta, name: LanguageName.ta },
    { code: LanguageCode.te, name: LanguageName.te },
    { code: LanguageCode.th, name: LanguageName.th },
    { code: LanguageCode.tr, name: LanguageName.tr },
    { code: LanguageCode.uk, name: LanguageName.uk },
    { code: LanguageCode.ur, name: LanguageName.ur },
    { code: LanguageCode.uz, name: LanguageName.uz },
    { code: LanguageCode.vi, name: LanguageName.vi },
    { code: LanguageCode.zu, name: LanguageName.zu },
  ];

}
